import React from 'react';
import {useIntl} from "react-intl";
import {usePriceQuoteDetailsContext} from '../../contexts/PriceQuoteDetailsContext';
import ButtonAction from "../../../_common/components/ButtonAction";
import Tabs from "../../../_common/components/Tabs";
import TempInspection from "./TempInspection";
import {StreetsProvider} from "../../../_common/components/CitiesAndStreets";
import {DecisionTreeShumaTypesOptionsContextProvider} from "../../../_common/components/DecisionTreeOptions";
import {useTempInspectionsListContext} from "../../contexts/TempInspectionsListContext";
import {TempInspectionProvider, useTempInspectionContext} from "../../contexts/TempInspectionContext";

const TabTempInspections = () => {
  const {formatMessage} = useIntl();
  const {orderID} = usePriceQuoteDetailsContext();
  const {
    formikTempInspections,
    handleCreate,
    initialForm,
    arrayHelpers,
    getInspections
  } = useTempInspectionsListContext();
  const {values, isValid, dirty} = formikTempInspections;
  const {inspections} = values;

  const tabs = inspections.map((item, index: number) => {
    return {
      key: index,
      title: `דוח ${Boolean(item?.tempShumaID) ? item?.tempShumaID : 'חדש'}`,
      icon: <i className="flaticon2-file-1"/>,
      content:
        <StreetsProvider>
          <DecisionTreeShumaTypesOptionsContextProvider>
            <TempInspectionProvider index={index}>
              <TempInspection
                index={index}
                orderID={orderID}
                useContext={useTempInspectionContext}
              />
            </TempInspectionProvider>
          </DecisionTreeShumaTypesOptionsContextProvider>
        </StreetsProvider>
    };
  });

  const handleAddTab = () => arrayHelpers.push(initialForm);

  const handleClick = async () => {
    await handleCreate(formikTempInspections.values)
    await getInspections();
  };

  return (
    <div className={'position-relative'}>
      <ButtonAction
        variant={'warning'}
        useIcon={'/media/common/Plus_white.svg'}
        label={'הוסף כרטיסייה'}
        onClick={handleAddTab}
        disabled={!!orderID}
        avoidDoubleClick={false}
        customClassnames={'position-absolute right-0 top-0 mt-n20'}
      />
      <Tabs defaultTab={0} items={tabs as unknown as never}/>
      <ButtonAction
        onClick={handleClick}
        disabled={!!orderID || !(isValid && dirty)}
        useIcon={'/media/common/Check-in-circle_white.svg'}
        label={formatMessage({id: 'button-save', defaultMessage: 'Save'})}
        customClassnames={'d-block mx-auto mt-8 w-150px'}
      />
    </div>
  );
};

export default TabTempInspections;